export enum EmailStatus {
    Declared = "declared",
    Sent = "sent",
    Delivering = "delivering",
    Delivered = "delivered",
    Opened = "opened",
    Error = "error",
}

export const EmailStatusInfo: Record<EmailStatus, { label: string }> = {
    [EmailStatus.Declared]: { label: "Déclaré" },
    [EmailStatus.Sent]: { label: "Envoyé" },
    [EmailStatus.Delivering]: { label: "En distribution" },
    [EmailStatus.Delivered]: { label: "Distribué" },
    [EmailStatus.Opened]: { label: "Ouvert" },
    [EmailStatus.Error]: { label: "Erreur" },
};
